import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import BPManageForecastMainContent from "./BPManageForecastMainContent";
import { BPBottlerSelectionProvider } from "../../../context/BPBottlerSelectionContext";
import { BPCustomBottlerSelectionProvider } from "../../../context/BPCustomBottlerSelectionContext";
import { setActiveDataElement } from "../../../redux/userSlice";

const BPManageForecast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Business Plan"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/bp-manage-forecast" },
                { title: "Manage Plan" },
              ]}
              title="Manage Business Plan File"
            />
            <div className="container">
              <BPBottlerSelectionProvider>
                <BPCustomBottlerSelectionProvider>
                  <BPManageForecastMainContent></BPManageForecastMainContent>
                </BPCustomBottlerSelectionProvider>
              </BPBottlerSelectionProvider>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default BPManageForecast;
